import * as yup from 'yup';
import { RoleDetailsFormValues } from './types';

export const roleDetailsValidationSchema: yup.ObjectSchema<RoleDetailsFormValues> =
  yup.object({
    name: yup.string().required('Name is required'),
    teamId: yup.string().required('Team is required'),
    description: yup.string().required('Description is required'),
    modifiers: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          value: yup.string().required('This field is required'),
        }),
      )
      .default([]),
    selectedPermissionIds: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one role or permission'),
  });
